import React, { useState } from "react";
import SettingsTabs from "./SettingsTabs";
import "./Settings.css";

const DashboardIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path d="M10 6V0H18V6H10ZM0 10V0H8V10H0ZM10 18V8H18V18H10ZM0 18V12H8V18H0ZM2 8H6V2H2V8ZM12 16H16V10H12V16ZM12 4H16V2H12V4ZM2 16H6V14H2V16Z" fill="currentColor"/>
  </svg>
);
const VehicleIcon = () => (
<svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 14V15C3 15.2833 2.90417 15.5208 2.7125 15.7125C2.52083 15.9042 2.28333 16 2 16H1C0.716667 16 0.479167 15.9042 0.2875 15.7125C0.0958333 15.5208 0 15.2833 0 15V7L2.1 1C2.2 0.7 2.37917 0.458333 2.6375 0.275C2.89583 0.0916667 3.18333 0 3.5 0H14.5C14.8167 0 15.1042 0.0916667 15.3625 0.275C15.6208 0.458333 15.8 0.7 15.9 1L18 7V15C18 15.2833 17.9042 15.5208 17.7125 15.7125C17.5208 15.9042 17.2833 16 17 16H16C15.7167 16 15.4792 15.9042 15.2875 15.7125C15.0958 15.5208 15 15.2833 15 15V14H3ZM2.8 5H15.2L14.15 2H3.85L2.8 5ZM2 7V12V7ZM4.5 11C4.91667 11 5.27083 10.8542 5.5625 10.5625C5.85417 10.2708 6 9.91667 6 9.5C6 9.08333 5.85417 8.72917 5.5625 8.4375C5.27083 8.14583 4.91667 8 4.5 8C4.08333 8 3.72917 8.14583 3.4375 8.4375C3.14583 8.72917 3 9.08333 3 9.5C3 9.91667 3.14583 10.2708 3.4375 10.5625C3.72917 10.8542 4.08333 11 4.5 11ZM13.5 11C13.9167 11 14.2708 10.8542 14.5625 10.5625C14.8542 10.2708 15 9.91667 15 9.5C15 9.08333 14.8542 8.72917 14.5625 8.4375C14.2708 8.14583 13.9167 8 13.5 8C13.0833 8 12.7292 8.14583 12.4375 8.4375C12.1458 8.72917 12 9.08333 12 9.5C12 9.91667 12.1458 10.2708 12.4375 10.5625C12.7292 10.8542 13.0833 11 13.5 11ZM2 12H16V7H2V12Z" fill="white"/>
</svg>
);
const CheckInIcon = () => (
<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.55 17.1V15.2H15.2V1.9H8.55V0H15.2C15.7225 0 16.1698 0.186042 16.5419 0.558125C16.914 0.930208 17.1 1.3775 17.1 1.9V15.2C17.1 15.7225 16.914 16.1698 16.5419 16.5419C16.1698 16.914 15.7225 17.1 15.2 17.1H8.55ZM6.65 13.3L5.34375 11.9225L7.76625 9.5H0V7.6H7.76625L5.34375 5.1775L6.65 3.8L11.4 8.55L6.65 13.3Z" fill="white"/>
</svg>
);
const CheckOutIcon = () => (
<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 18C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H9V2H2V16H9V18H2ZM13 14L11.625 12.55L14.175 10H6V8H14.175L11.625 5.45L13 4L18 9L13 14Z" fill="white"/>
</svg>
);
const AnalyticsIcon  = () => (
<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 14H6V9H4V14ZM12 14H14V4H12V14ZM8 14H10V11H8V14ZM8 9H10V7H8V9ZM2 18C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H16C16.55 0 17.0208 0.195833 17.4125 0.5875C17.8042 0.979167 18 1.45 18 2V16C18 16.55 17.8042 17.0208 17.4125 17.4125C17.0208 17.8042 16.55 18 16 18H2ZM2 16H16V2H2V16ZM2 2V16V2Z" fill="white"/>
</svg>
);
const SettingsIcon  = () => (
<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.3 20L6.9 16.8C6.68333 16.7167 6.47917 16.6167 6.2875 16.5C6.09583 16.3833 5.90833 16.2583 5.725 16.125L2.75 17.375L0 12.625L2.575 10.675C2.55833 10.5583 2.55 10.4458 2.55 10.3375C2.55 10.2292 2.55 10.1167 2.55 10C2.55 9.88333 2.55 9.77083 2.55 9.6625C2.55 9.55417 2.55833 9.44167 2.575 9.325L0 7.375L2.75 2.625L5.725 3.875C5.90833 3.74167 6.1 3.61667 6.3 3.5C6.5 3.38333 6.7 3.28333 6.9 3.2L7.3 0H12.8L13.2 3.2C13.4167 3.28333 13.6208 3.38333 13.8125 3.5C14.0042 3.61667 14.1917 3.74167 14.375 3.875L17.35 2.625L20.1 7.375L17.525 9.325C17.5417 9.44167 17.55 9.55417 17.55 9.6625C17.55 9.77083 17.55 9.88333 17.55 10C17.55 10.1167 17.55 10.2292 17.55 10.3375C17.55 10.4458 17.5333 10.5583 17.5 10.675L20.075 12.625L17.325 17.375L14.375 16.125C14.1917 16.2583 14 16.3833 13.8 16.5C13.6 16.6167 13.4 16.7167 13.2 16.8L12.8 20H7.3ZM9.05 18H11.025L11.375 15.35C11.8917 15.2167 12.3708 15.0208 12.8125 14.7625C13.2542 14.5042 13.6583 14.1917 14.025 13.825L16.5 14.85L17.475 13.15L15.325 11.525C15.4083 11.2917 15.4667 11.0458 15.5 10.7875C15.5333 10.5292 15.55 10.2667 15.55 10C15.55 9.73333 15.5333 9.47083 15.5 9.2125C15.4667 8.95417 15.4083 8.70833 15.325 8.475L17.475 6.85L16.5 5.15L14.025 6.2C13.6583 5.81667 13.2542 5.49583 12.8125 5.2375C12.3708 4.97917 11.8917 4.78333 11.375 4.65L11.05 2H9.075L8.725 4.65C8.20833 4.78333 7.72917 4.97917 7.2875 5.2375C6.84583 5.49583 6.44167 5.80833 6.075 6.175L3.6 5.15L2.625 6.85L4.775 8.45C4.69167 8.7 4.63333 8.95 4.6 9.2C4.56667 9.45 4.55 9.71667 4.55 10C4.55 10.2667 4.56667 10.525 4.6 10.775C4.63333 11.025 4.69167 11.275 4.775 11.525L2.625 13.15L3.6 14.85L6.075 13.8C6.44167 14.1833 6.84583 14.5042 7.2875 14.7625C7.72917 15.0208 8.20833 15.2167 8.725 15.35L9.05 18ZM10.1 13.5C11.0667 13.5 11.8917 13.1583 12.575 12.475C13.2583 11.7917 13.6 10.9667 13.6 10C13.6 9.03333 13.2583 8.20833 12.575 7.525C11.8917 6.84167 11.0667 6.5 10.1 6.5C9.11667 6.5 8.2875 6.84167 7.6125 7.525C6.9375 8.20833 6.6 9.03333 6.6 10C6.6 10.9667 6.9375 11.7917 7.6125 12.475C8.2875 13.1583 9.11667 13.5 10.1 13.5Z" fill="#432DD7"/>
</svg>
);
const CompanyIcon = () => (
  <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 2V0H17V2H1ZM1 16V10H0V8L1 3H17L18 8V10H17V16H15V10H11V16H1ZM3 14H9V10H3V14ZM2.05 8H15.95H2.05ZM2.05 8H15.95L15.35 5H2.65L2.05 8Z" fill="#4F3DE3"/>
</svg>
);
const CameraIcon = () => (
 <svg width="33" height="30" viewBox="0 0 33 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 30C2.175 30 1.46875 29.7062 0.88125 29.1187C0.29375 28.5312 0 27.825 0 27V9C0 8.175 0.29375 7.46875 0.88125 6.88125C1.46875 6.29375 2.175 6 3 6H7.725L10.5 3H19.5V6H11.8125L9.075 9H3V27H27V13.5H30V27C30 27.825 29.7062 28.5312 29.1187 29.1187C28.5312 29.7062 27.825 30 27 30H3ZM27 9V6H24V3H27V0H30V3H33V6H30V9H27ZM15 24.75C16.875 24.75 18.4688 24.0938 19.7812 22.7812C21.0938 21.4688 21.75 19.875 21.75 18C21.75 16.125 21.0938 14.5312 19.7812 13.2188C18.4688 11.9062 16.875 11.25 15 11.25C13.125 11.25 11.5312 11.9062 10.2188 13.2188C8.90625 14.5312 8.25 16.125 8.25 18C8.25 19.875 8.90625 21.4688 10.2188 22.7812C11.5312 24.0938 13.125 24.75 15 24.75ZM15 21.75C13.95 21.75 13.0625 21.3875 12.3375 20.6625C11.6125 19.9375 11.25 19.05 11.25 18C11.25 16.95 11.6125 16.0625 12.3375 15.3375C13.0625 14.6125 13.95 14.25 15 14.25C16.05 14.25 16.9375 14.6125 17.6625 15.3375C18.3875 16.0625 18.75 16.95 18.75 18C18.75 19.05 18.3875 19.9375 17.6625 20.6625C16.9375 21.3875 16.05 21.75 15 21.75Z" fill="#B4A6D5"/>
</svg>
);
const WarningIcon = () => (
 <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M32.3273 26.775L20.4272 5.94983C20.1677 5.49198 19.7914 5.11116 19.3367 4.8462C18.882 4.58125 18.3652 4.44165 17.8389 4.44165C17.3126 4.44165 16.7958 4.58125 16.3411 4.8462C15.8864 5.11116 15.5101 5.49198 15.2506 5.94983L3.35055 26.775C3.08828 27.2292 2.95075 27.7447 2.95191 28.2692C2.95307 28.7937 3.09288 29.3086 3.35717 29.7617C3.62145 30.2147 4.00081 30.5898 4.45681 30.849C4.9128 31.1082 5.42921 31.2422 5.9537 31.2375H29.7539C30.2758 31.237 30.7885 31.0991 31.2403 30.8378C31.6922 30.5765 32.0673 30.2009 32.328 29.7487C32.5888 29.2965 32.726 28.7837 32.7259 28.2617C32.7257 27.7398 32.5883 27.227 32.3273 26.775Z" stroke="#E7000B" stroke-width="2.97502" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M17.8516 13.3872V19.3373" stroke="#E7000B" stroke-width="2.97502" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M17.8516 25.2886H17.864" stroke="#E7000B" stroke-width="2.97502" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

);
const CompanyNameIcon = () => (
  <svg width="15" height="14" viewBox="0 0 15 14" fill="none">
    <path
      d="M0 13.5V0H7.5V3H15V13.5H0ZM1.5 12H3V10.5H1.5V12ZM1.5 9H3V7.5H1.5V9ZM1.5 6H3V4.5H1.5V6ZM1.5 3H3V1.5H1.5V3ZM4.5 12H6V10.5H4.5V12ZM4.5 9H6V7.5H4.5V9ZM4.5 6H6V4.5H4.5V6ZM4.5 3H6V1.5H4.5V3ZM7.5 12H13.5V4.5H7.5V6H9V7.5H7.5V9H9V10.5H7.5V12ZM10.5 7.5V6H12V7.5H10.5ZM10.5 10.5V9H12V10.5H10.5Z"
      fill="#61557F"
    />
  </svg>
);
const FloorIcon = () => (
  <svg width="14" height="15" viewBox="0 0 14 15" fill="none">
    <path
      d="M6.75 14.2875L0 9.0375L1.2375 8.1L6.75 12.375L12.2625 8.1L13.5 9.0375L6.75 14.2875ZM6.75 10.5L0 5.25L6.75 0L13.5 5.25L6.75 10.5ZM6.75 8.5875L11.0625 5.25L6.75 1.9125L2.4375 5.25L6.75 8.5875Z"
      fill="#61557F"
    />
  </svg>
);
const BikeIcon = () => (
  <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.75 12C2.6875 12 1.79688 11.6406 1.07812 10.9219C0.359375 10.2031 0 9.3125 0 8.25C0 7.1875 0.365625 6.29688 1.09687 5.57812C1.82812 4.85938 2.7125 4.5 3.75 4.5C4.7125 4.5 5.52187 4.7875 6.17812 5.3625C6.83437 5.9375 7.25 6.65 7.425 7.5H7.9125L6.5625 3.75H5.25V2.25H9V3.75H8.175L8.4375 4.5H12.0375L10.95 1.5H9V0H10.95C11.275 0 11.5656 0.0875 11.8219 0.2625C12.0781 0.4375 12.2625 0.675 12.375 0.975L13.65 4.4625H14.25C15.2875 4.4625 16.1719 4.82812 16.9031 5.55937C17.6344 6.29062 18 7.175 18 8.2125C18 9.2625 17.6375 10.1562 16.9125 10.8938C16.1875 11.6313 15.3 12 14.25 12C13.35 12 12.5594 11.7188 11.8781 11.1562C11.1969 10.5938 10.7625 9.875 10.575 9H7.425C7.25 9.8625 6.825 10.5781 6.15 11.1469C5.475 11.7156 4.675 12 3.75 12ZM3.75 10.5C4.2625 10.5 4.70312 10.3594 5.07188 10.0781C5.44063 9.79688 5.7 9.4375 5.85 9H3.75V7.5H5.85C5.7 7.05 5.44063 6.6875 5.07188 6.4125C4.70312 6.1375 4.2625 6 3.75 6C3.1125 6 2.57812 6.21562 2.14687 6.64687C1.71562 7.07812 1.5 7.6125 1.5 8.25C1.5 8.875 1.71562 9.40625 2.14687 9.84375C2.57812 10.2812 3.1125 10.5 3.75 10.5ZM9.525 7.5H10.575C10.6375 7.2125 10.7219 6.94375 10.8281 6.69375C10.9344 6.44375 11.075 6.2125 11.25 6H8.9625L9.525 7.5ZM14.25 10.5C14.8875 10.5 15.4219 10.2812 15.8531 9.84375C16.2844 9.40625 16.5 8.875 16.5 8.25C16.5 7.6125 16.2844 7.07812 15.8531 6.64687C15.4219 6.21562 14.8875 6 14.25 6C14.225 6 14.2125 6 14.2125 6C14.2125 6 14.2 6 14.175 6L14.925 7.9875L13.5 8.5125L12.7875 6.525C12.5375 6.7375 12.3438 6.9875 12.2063 7.275C12.0688 7.5625 12 7.8875 12 8.25C12 8.875 12.2156 9.40625 12.6469 9.84375C13.0781 10.2812 13.6125 10.5 14.25 10.5Z" fill="#61557F"/>
</svg>

);
const ZoneIcon = () => (
  <svg width="12" height="15" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6 7.5C6.4125 7.5 6.76562 7.35312 7.05937 7.05937C7.35312 6.76562 7.5 6.4125 7.5 6C7.5 5.5875 7.35312 5.23438 7.05937 4.94063C6.76562 4.64688 6.4125 4.5 6 4.5C5.5875 4.5 5.23438 4.64688 4.94063 4.94063C4.64688 5.23438 4.5 5.5875 4.5 6C4.5 6.4125 4.64688 6.76562 4.94063 7.05937C5.23438 7.35312 5.5875 7.5 6 7.5ZM6 13.0125C7.525 11.6125 8.65625 10.3406 9.39375 9.19687C10.1313 8.05312 10.5 7.0375 10.5 6.15C10.5 4.7875 10.0656 3.67188 9.19687 2.80312C8.32812 1.93437 7.2625 1.5 6 1.5C4.7375 1.5 3.67188 1.93437 2.80312 2.80312C1.93437 3.67188 1.5 4.7875 1.5 6.15C1.5 7.0375 1.86875 8.05312 2.60625 9.19687C3.34375 10.3406 4.475 11.6125 6 13.0125ZM6 15C3.9875 13.2875 2.48438 11.6969 1.49063 10.2281C0.496875 8.75937 0 7.4 0 6.15C0 4.275 0.603125 2.78125 1.80938 1.66875C3.01562 0.55625 4.4125 0 6 0C7.5875 0 8.98438 0.55625 10.1906 1.66875C11.3969 2.78125 12 4.275 12 6.15C12 7.4 11.5031 8.75937 10.5094 10.2281C9.51562 11.6969 8.0125 13.2875 6 15Z" fill="#61557F"/>
</svg>

);
const CarIcon = () => (
  <svg width="22" height="14" viewBox="0 0 22 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18 11H20C20.6 11 21 10.6 21 10V7C21 6.1 20.3 5.3 19.5 5.1C17.7 4.6 15 4 15 4C15 4 13.7 2.6 12.8 1.7C12.3 1.3 11.7 1 11 1H4C3.4 1 2.9 1.4 2.6 1.9L1.2 4.8C1.06758 5.18623 1 5.5917 1 6V10C1 10.6 1.4 11 2 11H4" stroke="#61557F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6 13C7.10457 13 8 12.1046 8 11C8 9.89543 7.10457 9 6 9C4.89543 9 4 9.89543 4 11C4 12.1046 4.89543 13 6 13Z" stroke="#61557F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8 11H14" stroke="#61557F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M16 13C17.1046 13 18 12.1046 18 11C18 9.89543 17.1046 9 16 9C14.8954 9 14 9.89543 14 11C14 12.1046 14.8954 13 16 13Z" stroke="#61557F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
);
const DropdownIcon = () => (
  <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.900391 0.899902L5.70039 5.6999L10.5004 0.899902" stroke="#6B7280" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
);
const PenIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.4334 13.6H2.64465L10.9534 5.29125L9.74215 4.08L1.4334 12.3888V13.6ZM-0.266602 15.3V11.6875L10.9534 0.48875C11.1234 0.332917 11.3112 0.2125 11.5169 0.1275C11.7226 0.0425001 11.9385 0 12.1646 0C12.3907 0 12.6103 0.0425001 12.8234 0.1275C13.0365 0.2125 13.2206 0.34 13.3759 0.51L14.5446 1.7C14.7146 1.85583 14.8387 2.04 14.9169 2.2525C14.9951 2.465 15.034 2.6775 15.0334 2.89C15.0334 3.11667 14.9946 3.33285 14.9169 3.53855C14.8393 3.74425 14.7152 3.93182 14.5446 4.10125L3.3459 15.3H-0.266602ZM10.3371 4.69625L9.74215 4.08L10.9534 5.29125L10.3371 4.69625Z" fill="#6B7280"/>
</svg>
);
const SaveIcon = () => (
  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.4163 3.20362V12.8145C14.4163 13.255 14.2596 13.6322 13.9462 13.9462C13.6327 14.2601 13.2555 14.4168 12.8145 14.4163H1.60181C1.16131 14.4163 0.784353 14.2596 0.470932 13.9462C0.157511 13.6327 0.000533937 13.2555 0 12.8145V1.60181C0 1.16131 0.156977 0.784353 0.470932 0.470932C0.784887 0.157511 1.16185 0.000533937 1.60181 0H11.2127L14.4163 3.20362ZM12.8145 3.88439L10.5319 1.60181H1.60181V12.8145H12.8145V3.88439ZM8.91007 11.3128C9.37726 10.8456 9.61086 10.2783 9.61086 9.61086C9.61086 8.94344 9.37726 8.37613 8.91007 7.90894C8.44287 7.44174 7.87557 7.20815 7.20815 7.20815C6.54072 7.20815 5.97342 7.44174 5.50622 7.90894C5.03903 8.37613 4.80543 8.94344 4.80543 9.61086C4.80543 10.2783 5.03903 10.8456 5.50622 11.3128C5.97342 11.78 6.54072 12.0136 7.20815 12.0136C7.87557 12.0136 8.44287 11.78 8.91007 11.3128ZM2.40271 5.60633H9.61086V2.40271H2.40271V5.60633ZM1.60181 3.88439V12.8145V1.60181V3.88439Z" fill="white"/>
</svg>
);
const CloudIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 16V14H2.75L2.35 13.65C1.48333 12.8833 0.875 12.0083 0.525 11.025C0.175 10.0417 0 9.05 0 8.05C0 6.2 0.554167 4.55417 1.6625 3.1125C2.77083 1.67083 4.21667 0.716667 6 0.25V2.35C4.8 2.78333 3.83333 3.52083 3.1 4.5625C2.36667 5.60417 2 6.76667 2 8.05C2 8.8 2.14167 9.52917 2.425 10.2375C2.70833 10.9458 3.15 11.6 3.75 12.2L4 12.45V10H6V16H0ZM10 15.75V13.65C11.2 13.2167 12.1667 12.4792 12.9 11.4375C13.6333 10.3958 14 9.23333 14 7.95C14 7.2 13.8583 6.47083 13.575 5.7625C13.2917 5.05417 12.85 4.4 12.25 3.8L12 3.55V6H10V0H16V2H13.25L13.65 2.35C14.4667 3.16667 15.0625 4.05417 15.4375 5.0125C15.8125 5.97083 16 6.95 16 7.95C16 9.8 15.4458 11.4458 14.3375 12.8875C13.2292 14.3292 11.7833 15.2833 10 15.75Z" fill="#3C28C1"/>
</svg>
);
const ShieldIcon = () => (
  <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 20C5.68333 19.4167 3.77083 18.0875 2.2625 16.0125C0.754167 13.9375 0 11.6333 0 9.1V3L8 0L16 3V9.1C16 11.6333 15.2458 13.9375 13.7375 16.0125C12.2292 18.0875 10.3167 19.4167 8 20ZM8 17.9C9.61667 17.4 10.9667 16.4125 12.05 14.9375C13.1333 13.4625 13.7667 11.8167 13.95 10H8V2.125L2 4.375V9.1C2 9.28333 2 9.43333 2 9.55C2 9.66667 2.01667 9.81667 2.05 10H8V17.9Z" fill="#3C28C1"/>
</svg>
);
const UploadIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.41667 11.0323C1.02708 11.0323 0.693694 10.8937 0.4165 10.6165C0.139305 10.3393 0.000472222 10.0057 0 9.61564V8.19897C0 7.99827 0.0680001 7.83016 0.204 7.69464C0.34 7.55911 0.508111 7.49111 0.708333 7.49064C0.908556 7.49016 1.0769 7.55816 1.21337 7.69464C1.34985 7.83111 1.41761 7.99922 1.41667 8.19897V9.61564H9.91667V8.19897C9.91667 7.99827 9.98467 7.83016 10.1207 7.69464C10.2567 7.55911 10.4248 7.49111 10.625 7.49064C10.8252 7.49016 10.9936 7.55816 11.13 7.69464C11.2665 7.83111 11.3343 7.99922 11.3333 8.19897V9.61564C11.3333 10.0052 11.1947 10.3388 10.9175 10.6165C10.6403 10.8942 10.3067 11.0328 9.91667 11.0323H1.41667ZM4.95833 2.42605L3.63021 3.75418C3.48854 3.89584 3.32043 3.96384 3.12587 3.95818C2.93132 3.95251 2.76297 3.87861 2.62083 3.73647C2.49097 3.5948 2.42297 3.42952 2.41683 3.24064C2.41069 3.05175 2.47869 2.88647 2.62083 2.7448L5.17083 0.194802C5.24167 0.123969 5.3184 0.0739135 5.40104 0.0446357C5.48368 0.0153579 5.57222 0.00048312 5.66667 1.08976e-05C5.76111 -0.000461325 5.84965 0.0144135 5.93229 0.0446357C6.01493 0.0748579 6.09167 0.124913 6.1625 0.194802L8.7125 2.7448C8.85417 2.88647 8.92217 3.05175 8.9165 3.24064C8.91083 3.42952 8.84283 3.5948 8.7125 3.73647C8.57083 3.87814 8.40272 3.95204 8.20817 3.95818C8.01361 3.96432 7.84526 3.89632 7.70312 3.75418L6.375 2.42605V7.49064C6.375 7.69133 6.307 7.85968 6.171 7.99568C6.035 8.13168 5.86689 8.19944 5.66667 8.19897C5.46644 8.1985 5.29833 8.1305 5.16233 7.99497C5.02633 7.85944 4.95833 7.69133 4.95833 7.49064V2.42605Z" fill="white"/>
</svg>
);
const ZonesprofileIcon = () => (
  <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.66677 0C3.88927 0 0.000101984 3.88917 0.000101984 8.66667C-0.032398 15.6433 7.71344 21.2333 8.03844 21.4717C8.2226 21.6017 8.4501 21.6775 8.66677 21.6775C8.88344 21.6775 9.11094 21.6125 9.2951 21.4717C9.6201 21.2333 17.3659 15.6542 17.3334 8.66667C17.3334 3.88917 13.4443 0 8.66677 0ZM8.66677 13C6.2726 13 4.33344 11.0608 4.33344 8.66667C4.33344 6.2725 6.2726 4.33333 8.66677 4.33333C11.0609 4.33333 13.0001 6.2725 13.0001 8.66667C13.0001 11.0608 11.0609 13 8.66677 13Z" fill="url(#paint0_linear_1_10805)"/>
<defs>
<linearGradient id="paint0_linear_1_10805" x1="0.149829" y1="15.3045" x2="17.2856" y2="15.3787" gradientUnits="userSpaceOnUse">
<stop stop-color="#A196EB"/>
<stop offset="0.5" stop-color="#2E1E95"/>
<stop offset="1" stop-color="#432DD7"/>
</linearGradient>
</defs>
</svg>
);
const PlusIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10 0C4.477 0 0 4.477 0 10C0 15.523 4.477 20 10 20C15.523 20 20 15.523 20 10C20 4.477 15.523 0 10 0ZM15 11H11V15H9V11H5V9H9V5H11V9H15V11Z" fill="#493AA8"/>
</svg>
);
const TickIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z" fill="#F5F1FF"/>
</svg>
);
const FloorprofileIcon = () => (
  <svg width="23" height="18" viewBox="0 0 23 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M22.3662 10.6913C22.5142 10.9877 22.5385 11.3307 22.4337 11.645C22.329 11.9593 22.1037 12.2192 21.8074 12.3675L11.8074 17.3675C11.6339 17.4542 11.4426 17.4993 11.2487 17.4993C11.0547 17.4993 10.8634 17.4542 10.6899 17.3675L0.689916 12.3675C0.404006 12.2133 0.189342 11.9539 0.091396 11.6442C-0.00655044 11.3345 0.0199138 10.9988 0.165183 10.7083C0.310452 10.4177 0.563116 10.1951 0.869654 10.0877C1.17619 9.9802 1.51253 9.99628 1.80742 10.1325L11.2487 14.85L20.6912 10.1313C20.9876 9.98322 21.3306 9.95893 21.6449 10.0637C21.9592 10.1685 22.2191 10.3937 22.3674 10.69M11.2587 0C11.3053 0 11.3516 0.00291663 11.3974 0.00874996L11.5362 0.0337499L11.6437 0.0637502L11.6587 0.0712502L11.6737 0.07375L11.7099 0.09125L11.7724 0.115L11.7924 0.12625L11.8074 0.1325L21.8074 5.1325C22.0148 5.23642 22.1891 5.39599 22.311 5.59334C22.4328 5.7907 22.4973 6.01806 22.4973 6.25C22.4973 6.48194 22.4328 6.7093 22.311 6.90666C22.1891 7.10401 22.0148 7.26358 21.8074 7.3675L11.8074 12.3675C11.6339 12.4542 11.4426 12.4993 11.2487 12.4993C11.0547 12.4993 10.8634 12.4542 10.6899 12.3675L0.689916 7.3675C0.482564 7.26358 0.308215 7.10401 0.186373 6.90666C0.0645305 6.7093 0 6.48194 0 6.25C0 6.01806 0.0645305 5.7907 0.186373 5.59334C0.308215 5.39599 0.482564 5.23642 0.689916 5.1325L10.6899 0.1325L10.7037 0.12625L10.7262 0.11375L10.8237 0.07375L10.8374 0.0712502L10.8537 0.0637502L10.9612 0.0337499L11.0987 0.00874996L11.1687 0.00249982L11.2587 0Z" fill="url(#paint0_linear_1_11246)"/>
<defs>
<linearGradient id="paint0_linear_1_11246" x1="0.194469" y1="12.3547" x2="22.435" y2="12.5095" gradientUnits="userSpaceOnUse">
<stop stop-color="#A196EB"/>
<stop offset="0.5" stop-color="#2E1E95"/>
<stop offset="1" stop-color="#432DD7"/>
</linearGradient>
</defs>
</svg>
);
const ClockIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.3 14.7L14.7 13.3L11 9.6V5H9V10.4L13.3 14.7ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20Z" fill="#4F3DE3"/>
</svg>
);
const WeekendsIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 0C13.2449 3.23106e-05 13.4813 0.0899562 13.6644 0.252715C13.8474 0.415475 13.9643 0.639749 13.993 0.883L14 1V2H16C16.5046 1.99984 16.9906 2.19041 17.3605 2.5335C17.7305 2.87659 17.9572 3.34684 17.995 3.85L18 4V16C18.0002 16.5046 17.8096 16.9906 17.4665 17.3605C17.1234 17.7305 16.6532 17.9572 16.15 17.995L16 18H2C1.49542 18.0002 1.00943 17.8096 0.639452 17.4665C0.269471 17.1234 0.0428434 16.6532 0.00500021 16.15L1.00268e-07 16V4C-0.000159579 3.49542 0.190406 3.00943 0.533497 2.63945C0.876588 2.26947 1.34684 2.04284 1.85 2.005L2 2H4V1C4.00028 0.74512 4.09788 0.499968 4.27285 0.314632C4.44782 0.129296 4.68695 0.017765 4.94139 0.00282788C5.19584 -0.0121092 5.44638 0.0706746 5.64183 0.234265C5.83729 0.397855 5.9629 0.629904 5.993 0.883L6 1V2H12V1C12 0.734784 12.1054 0.48043 12.2929 0.292893C12.4804 0.105357 12.7348 0 13 0ZM16 9H2V16H16V9ZM16 4H2V7H16V4Z" fill="#5A33BE"/>
</svg>
);
const FestivalIcon = () => (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.5063 6.17C14.4063 6.07 14.2963 5.97 14.1863 5.87C14.4863 5.36 14.6763 4.75 14.6763 4C14.6763 1.07 12.2863 0 10.6763 0V2C11.1363 2 12.6763 2.17 12.6763 4C12.6763 4.18 12.6463 4.33 12.6063 4.48C11.5063 3.59 10.3963 2.85 9.36626 2.35C6.87626 1.16 5.60626 1.66 4.97626 2.29C4.80626 2.46 4.65626 2.67 4.53626 2.94C4.41626 3.21 4.49626 3.05 4.49626 3.05C4.45626 3.15 4.42626 3.25 4.39626 3.36L0.166258 16.34C-0.0260468 16.9198 -0.0520942 17.5419 0.0910683 18.1358C0.234231 18.7296 0.540879 19.2715 0.976258 19.7C1.60626 20.33 2.44626 20.67 3.30626 20.67C3.64626 20.67 3.99626 20.62 4.33626 20.51L17.4763 16.23C17.5563 16.2 17.6463 16.18 17.7263 16.15H17.7463C18.0163 16.03 18.2263 15.88 18.3963 15.71C19.0263 15.08 19.5263 13.81 18.3363 11.32C17.9201 10.4739 17.4281 9.66726 16.8663 8.91C17.6263 8.39 18.5663 8 19.6963 8V6C18.0263 6 16.6663 6.59 15.6163 7.34C15.2663 6.95 14.9063 6.56 14.5263 6.17H14.5063ZM9.52626 16.17C9.10626 15.97 8.63626 15.68 8.16626 15.33C7.65626 14.95 7.14626 14.51 6.65626 14.02C6.16626 13.53 5.72626 13.03 5.34626 12.51C5.02647 12.0825 4.74537 11.6274 4.50626 11.15C4.32626 10.77 4.24626 10.51 4.21626 10.34L5.26626 7.11C6.06626 8.63 7.30626 10.28 8.84626 11.82C10.3863 13.36 12.0363 14.6 13.5563 15.4L10.3263 16.45C10.1663 16.42 9.89626 16.35 9.51626 16.16L9.52626 16.17ZM3.71626 18.61C3.4866 18.6844 3.24085 18.6939 3.00614 18.6375C2.77142 18.581 2.55687 18.4608 2.38617 18.2901C2.21546 18.1194 2.09525 17.9048 2.0388 17.6701C1.98235 17.4354 1.99185 17.1897 2.06626 16.96L3.32626 13.09C3.45626 13.29 3.58626 13.49 3.73626 13.7C4.17626 14.29 4.67626 14.87 5.23626 15.43C5.79626 15.99 6.37626 16.49 6.96626 16.93C7.17626 17.08 7.37626 17.21 7.57626 17.34L3.70626 18.6L3.71626 18.61ZM16.9763 14.29C16.9763 14.29 16.9663 14.29 16.9563 14.3L16.7963 14.35C16.4963 14.39 15.8563 14.31 14.8563 13.84C13.4263 13.16 11.7963 11.94 10.2663 10.41C8.73626 8.88 7.52626 7.25 6.83626 5.82C6.35626 4.82 6.27626 4.18 6.32626 3.88L6.37626 3.72C6.37626 3.72 6.37626 3.7 6.38626 3.7C6.42626 3.66 6.53626 3.63 6.71626 3.63C7.05626 3.63 7.64626 3.75 8.50626 4.15C9.30626 4.53 10.1763 5.1 11.0563 5.78C10.3763 5.98 9.73626 5.99 9.68626 5.99V7.99C10.5263 7.99 11.7163 7.79 12.7363 7.23C12.8563 7.35 12.9863 7.45 13.1063 7.57C13.4663 7.93 13.8063 8.29 14.1263 8.66C13.2763 9.61 12.8363 10.46 12.7963 10.54L14.5863 11.43C14.5863 11.43 14.8663 10.89 15.3863 10.26C15.8463 10.91 16.2463 11.55 16.5363 12.16C17.1563 13.46 17.1063 14.16 16.9863 14.28L16.9763 14.29Z" fill="#5A33BE"/>
</svg>
);
const PenactionIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.16667 17.3333H3.71042L14.3 6.74375L12.7563 5.2L2.16667 15.7896V17.3333ZM0 19.5V14.8958L14.3 0.622917C14.5167 0.424306 14.7561 0.270833 15.0183 0.1625C15.2804 0.0541668 15.5556 0 15.8438 0C16.1319 0 16.4118 0.0541668 16.6833 0.1625C16.9549 0.270833 17.1896 0.433333 17.3875 0.65L18.8771 2.16667C19.0938 2.36528 19.2519 2.6 19.3516 2.87083C19.4513 3.14167 19.5007 3.4125 19.5 3.68333C19.5 3.97222 19.4505 4.24775 19.3516 4.50992C19.2526 4.77208 19.0945 5.01114 18.8771 5.22708L4.60417 19.5H0ZM13.5146 5.98542L12.7563 5.2L14.3 6.74375L13.5146 5.98542Z" fill="#3F34B0"/>
</svg>
);
const DeleteIcon = () => (
  <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.9167 6.5V17.3333H3.25V6.5H11.9167ZM10.2917 0H4.875L3.79167 1.08333H0V3.25H15.1667V1.08333H11.375L10.2917 0ZM14.0833 4.33333H1.08333V17.3333C1.08333 18.525 2.05833 19.5 3.25 19.5H11.9167C13.1083 19.5 14.0833 18.525 14.0833 17.3333V4.33333Z" fill="white"/>
</svg>
);
const CarfrontIcon = () => (
  <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 14V15C3 15.2833 2.90417 15.5208 2.7125 15.7125C2.52083 15.9042 2.28333 16 2 16H1C0.716667 16 0.479167 15.9042 0.2875 15.7125C0.0958333 15.5208 0 15.2833 0 15V7L2.1 1C2.2 0.7 2.37917 0.458333 2.6375 0.275C2.89583 0.0916667 3.18333 0 3.5 0H14.5C14.8167 0 15.1042 0.0916667 15.3625 0.275C15.6208 0.458333 15.8 0.7 15.9 1L18 7V15C18 15.2833 17.9042 15.5208 17.7125 15.7125C17.5208 15.9042 17.2833 16 17 16H16C15.7167 16 15.4792 15.9042 15.2875 15.7125C15.0958 15.5208 15 15.2833 15 15V14H3ZM2.8 5H15.2L14.15 2H3.85L2.8 5ZM2 7V12V7ZM4.5 11C4.91667 11 5.27083 10.8542 5.5625 10.5625C5.85417 10.2708 6 9.91667 6 9.5C6 9.08333 5.85417 8.72917 5.5625 8.4375C5.27083 8.14583 4.91667 8 4.5 8C4.08333 8 3.72917 8.14583 3.4375 8.4375C3.14583 8.72917 3 9.08333 3 9.5C3 9.91667 3.14583 10.2708 3.4375 10.5625C3.72917 10.8542 4.08333 11 4.5 11ZM13.5 11C13.9167 11 14.2708 10.8542 14.5625 10.5625C14.8542 10.2708 15 9.91667 15 9.5C15 9.08333 14.8542 8.72917 14.5625 8.4375C14.2708 8.14583 13.9167 8 13.5 8C13.0833 8 12.7292 8.14583 12.4375 8.4375C12.1458 8.72917 12 9.08333 12 9.5C12 9.91667 12.1458 10.2708 12.4375 10.5625C12.7292 10.8542 13.0833 11 13.5 11ZM2 12H16V7H2V12Z" fill="#61557F"/>
</svg>
);
const AddConfigurationButton = () => (
  <svg
    className="add-config-svg"
    width="916"
    height="74"
    viewBox="0 0 916 74"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1.5"
      y="1.5"
      width="913"
      height="71"
      rx="35.5"
      stroke="#BCB8FF"
      strokeWidth="3"
      strokeDasharray="16 16"
    />
    <path
      d="M321.392 26.5657C314.308 26.5657 308.565 32.3082 308.565 39.3925C308.565 46.4767 314.308 52.2193 321.392 52.2193C328.476 52.2193 334.219 46.4767 334.219 39.3925C334.219 32.3082 328.476 26.5657 321.392 26.5657ZM327.806 40.6751H322.675V45.8059H320.11V40.6751H314.979V38.1098H320.11V32.9791H322.675V38.1098H327.806V40.6751Z"
      fill="#493AA8"
    />
    {/* paste all remaining text paths here */}
  </svg>
);
const DeleteprofileIcon = () => (
  <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11 6V16H3V6H11ZM9.5 0H4.5L3.5 1H0V3H14V1H10.5L9.5 0ZM13 4H1V16C1 17.1 1.9 18 3 18H11C12.1 18 13 17.1 13 16V4Z" fill="#D71414"/>
</svg>
);
const GridSlabIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M0 16H7.27187V8.72812H0V16ZM0 7.27187H7.27187V0H0V7.27187ZM8.72812 16H16V8.72812H8.72812V16ZM8.72812 0V7.27187H16V0H8.72812Z" fill="#5A33BE"/>
  </svg>
);
const WheelchairSlabIcon = () => (
  <svg width="16" height="20" viewBox="0 0 16 20" fill="none">
    <path d="M5 19.5C3.61667 19.5 2.4375 19.0125 1.4625 18.0375C0.4875 17.0625 0 15.8833 0 14.5C0 13.1167 0.4875 11.9375 1.4625 10.9625C2.4375 9.9875 3.61667 9.5 5 9.5V11.5C4.16667 11.5 3.45833 11.7917 2.875 12.375C2.29167 12.9583 2 13.6667 2 14.5C2 15.3333 2.29167 16.0417 2.875 16.625C3.45833 17.2083 4.16667 17.5 5 17.5C5.83333 17.5 6.54167 17.2083 7.125 16.625C7.70833 16.0417 8 15.3333 8 14.5H10C10 15.8833 9.5125 17.0625 8.5375 18.0375C7.5625 19.0125 6.38333 19.5 5 19.5ZM14 18.5V13.5H8C7.26667 13.5 6.7 13.1875 6.3 12.5625C5.9 11.9375 5.85 11.2833 6.15 10.6L8 6.5H5.725L5.125 8.05L3.2 7.5L3.9 5.7C4.05 5.31667 4.29583 5.02083 4.6375 4.8125C4.97917 4.60417 5.35 4.5 5.75 4.5H10.95C11.7 4.5 12.2708 4.80417 12.6625 5.4125C13.0542 6.02083 13.1 6.66667 12.8 7.35L11.15 11H14C14.55 11 15.0208 11.1958 15.4125 11.5875C15.8042 11.9792 16 12.45 16 13V18.5H14ZM13 4C12.45 4 11.9792 3.80417 11.5875 3.4125C11.1958 3.02083 11 2.55 11 2C11 1.45 11.1958 0.979167 11.5875 0.5875C11.9792 0.195833 12.45 0 13 0C13.55 0 14.0208 0.195833 14.4125 0.5875C14.8042 0.979167 15 1.45 15 2C15 2.55 14.8042 3.02083 14.4125 3.4125C14.0208 3.80417 13.55 4 13 4Z" fill="#5A33BE"/>
  </svg>
);


export default function Settings({ setPage }) {
  const [activeTab, setActiveTab] = useState("general");
  const [settingsPage, setSettingsPage] = useState("settings");
  const [showZoneModal, setShowZoneModal] = useState(false);
  const [showFloorModal, setShowFloorModal] = useState(false);
  const [showEditPriceModal, setShowEditPriceModal] = useState(false);
  const [priceSlabs, setPriceSlabs] = useState([]);
  const [editingPriceIndex, setEditingPriceIndex] = useState(null);
  const [showDeletePriceModal, setShowDeletePriceModal] = useState(false);
  const [deletingPriceIndex, setDeletingPriceIndex] = useState(null);
  const [activeMenu, setActiveMenu] = useState("settings"); 

const [editPriceData, setEditPriceData] = useState({
  slabName: "",
  bikeRate: "",
  carRate: "",
  icon: "clock",
});
  const addPriceSlab = () => {
  setPriceSlabs([
    ...priceSlabs,
    {
      slabName: "",
      bikeRate: "",
      carRate: "",
      icon: "clock",
    },
  ]);
};
const renderSlabIcon = (icon) => {
  if (icon === "weekend") return <WeekendsIcon />;
  if (icon === "festival") return <FestivalIcon />;
  if (icon === "grid") return <GridSlabIcon />;
  if (icon === "wheelchair") return <WheelchairSlabIcon />;
  return <ClockIcon />;
};

const openEditPriceModal = (index) => {
  setEditingPriceIndex(index);
  setEditPriceData(priceSlabs[index]);
  setShowEditPriceModal(true);
};

const updatePriceSlab = () => {
  const updated = [...priceSlabs];
  updated[editingPriceIndex] = editPriceData;
  setPriceSlabs(updated);
  setShowEditPriceModal(false);
};
const openDeletePriceModal = (index) => {
  setDeletingPriceIndex(index);
  setShowDeletePriceModal(true);
};

const confirmDeletePriceSlab = () => {
  const updated = priceSlabs.filter((_, i) => i !== deletingPriceIndex);
  setPriceSlabs(updated);
  setShowDeletePriceModal(false);
  setDeletingPriceIndex(null);
};
  const [editingZone, setEditingZone] = useState(null);
  const [editingFloor, setEditingFloor] = useState(null);
const [selectedZone, setSelectedZone] = useState("");
const [selectedFloor, setSelectedFloor] = useState("");
const handleZoneSave = () => {
  setShowZoneModal(false);
};

const handleFloorSave = () => {
  setShowFloorModal(false);
};
  const [zones, setZones] = useState([]);
  const [floors, setFloors] = useState([]);
  const addZoneRow = () => {
  setZones([...zones, { name: "", capacity: "" }]);
};

const addFloorRow = () => {
  setFloors([...floors, { name: "", capacity: "" }]);
};
  const [logo, setLogo] = useState(null);
  const handleLogoUpload = (e) => {
  const file = e.target.files[0];

  if (file) {
    setLogo(URL.createObjectURL(file));
  }
};
  if (settingsPage === "priceSlab") {
  return (
    <div className="settings-page">
      <aside className="sidebar">
  <div
  className={activeMenu === "dashboard" ? "nav-item active" : "nav-item"}
  onClick={() => {
    setActiveMenu("dashboard");
    setPage("dashboard");
  }}
>
  <DashboardIcon />
  <span>Dashboard</span>
</div>

<div
  className={activeMenu === "vehicles" ? "nav-item active" : "nav-item"}
  onClick={() => setActiveMenu("vehicles")}
>
  <VehicleIcon />
  <span>Vehicles</span>
</div>

<div
  className={activeMenu === "checkin" ? "nav-item active" : "nav-item"}
  onClick={() => {
    setActiveMenu("checkin");
    setPage("checkin");
  }}
>
  <CheckInIcon />
  <span>Check-In</span>
</div>

<div
  className={activeMenu === "settings" ? "nav-item active" : "nav-item"}
  onClick={() => {
    setActiveMenu("settings");
  }}
>
  <CheckOutIcon />
  <span>Check-Out</span>
</div>

<div
  className={activeMenu === "analytics" ? "nav-item active" : "nav-item"}
  onClick={() => setActiveMenu("analytics")}
>
  <AnalyticsIcon />
  <span>Analytics</span>
</div>

<div
  className={activeMenu === "settings" ? "nav-item active" : "nav-item"}
  onClick={() => {
    setActiveMenu("settings");
    setPage("settings");
  }}
>
  <SettingsIcon />
  <span>Settings</span>
</div>
</aside>

      <main className="price-main">
        <h1>Settings</h1>

       <div className="breadcrumb"> 
          <span onClick={() => setSettingsPage("main")}>Settings</span>
          <span>›</span>
          <b className="price-slab-title">Price Slab Configuration</b>
        </div>

        <h2 className="price-title">Price slab Configuration</h2>
        <p className="price-desc">
          Configure and adjust the price slab for your Parking Lot and this settings will
          <br />
          applied on further usage of the application
        </p>

        <div className="price-card">
          <div className="price-table-head">
            <span>SLAB NAME</span>
            <span>RATE</span>
            <span>ACTIONS</span>
          </div>

          {priceSlabs.map((item, index) => (
            <div className="price-row" key={index}>
              <div className="slab-name">
                <div className="slab-icon">
  {renderSlabIcon(item.icon)}
</div>
                <span className="price-slab-name">
  {item.slabName || "Enter slab name"}
</span>
              </div>

              <div className="rate-boxes">
                <div className="rate-pill">
                  <BikeIcon />
                  <div>
                    <small>BIKES</small>
                    <b>
  <b>
  {item.bikeRate || "₹0"}
</b>

</b>
<span>/hr</span>
                  </div>
                </div>

                <div className="rate-pill">
                  <CarfrontIcon />
                  <div>
                    <small>CARS</small>
                    <b>
  <b>
  {item.carRate || "₹0"}
</b>

</b>
<span>/hr</span>
                  </div>
                </div>

                <button className="add-vehicle">
                  <span className="vehicle-plus"><PlusIcon /></span>
                 <span className="vehicle-text">ADD VEHICLE</span>
                 </button>
              </div>

              <div className="price-actions">
                <button className="edit-price" onClick={() => openEditPriceModal(index)}><PenactionIcon /></button>
                <button
  className="delete-price"
  onClick={() => openDeletePriceModal(index)}
>
  <DeleteIcon />
</button>
              </div>
            </div>
          ))}

          <button className="add-config" onClick={addPriceSlab}>
  <AddConfigurationButton />

  <div className="add-config-content">
    
    <span className="add-config-text">ADD CONFIGURATION</span>
  </div>
</button>
        </div>
        {showEditPriceModal && (
  <div className="modal-overlay">
    <div className="edit-config-modal">

      <button
        className="modal-close"
        onClick={() => setShowEditPriceModal(false)}
      >
        ×
      </button>

      <h2>Edit Configuration</h2>
      <p className="modal-subtitle">
        Change the price slab configuration
      </p>

      <label className="edit-label">SLAB NAME</label>
      <input
  className="edit-input"
  placeholder="Enter your slab name"
  value={editPriceData.slabName}
  onChange={(e) =>
    setEditPriceData({ ...editPriceData, slabName: e.target.value })
  }
/>

      <label className="edit-label">
        VEHICLE PRICE SLABS
      </label>

      <div className="edit-rate-row">
        
        <div className="edit-rate-pill">
          <BikeIcon />
          <div>
            <small>BIKES</small>
            <b>
  <input
  className="edit-rate-input"
  placeholder="Price"
  value={editPriceData.bikeRate}
  onChange={(e) =>
    setEditPriceData({ ...editPriceData, bikeRate: e.target.value })
  }
/>
</b>
<span>/hr</span>
          </div>
        </div>

        <div className="edit-rate-pill">
          <CarIcon />
          <div>
            <small>CARS</small>
            <b>
  <input
  className="edit-rate-input"
  placeholder="Price"
  value={editPriceData.carRate}
  onChange={(e) =>
    setEditPriceData({ ...editPriceData, carRate: e.target.value })
  }
/>
</b>
<span>/hr</span>
          </div>
        </div>
      </div>
<label className="edit-label">SLAB ICON</label>

<div className="slab-icons">
  <button
    type="button"
    className={`slab-select ${editPriceData.icon === "clock" ? "active" : ""}`}
    onClick={() => setEditPriceData({ ...editPriceData, icon: "clock" })}
  >
    <ClockIcon />
  </button>

  <button
    type="button"
    className={`slab-select ${editPriceData.icon === "weekend" ? "active" : ""}`}
    onClick={() => setEditPriceData({ ...editPriceData, icon: "weekend" })}
  >
    <WeekendsIcon />
  </button>

  <button
    type="button"
    className={`slab-select ${editPriceData.icon === "festival" ? "active" : ""}`}
    onClick={() => setEditPriceData({ ...editPriceData, icon: "festival" })}
  >
    <FestivalIcon />
  </button>

  <button
    type="button"
    className={`slab-select ${editPriceData.icon === "grid" ? "active" : ""}`}
    onClick={() => setEditPriceData({ ...editPriceData, icon: "grid" })}
  >
    <GridSlabIcon />
  </button>

  <button
    type="button"
    className={`slab-select ${editPriceData.icon === "wheelchair" ? "active" : ""}`}
    onClick={() => setEditPriceData({ ...editPriceData, icon: "wheelchair" })}
  >
    <WheelchairSlabIcon />
  </button>
</div>
      <div className="modal-actions">
        <button
          className="modal-cancel"
          onClick={() => setShowEditPriceModal(false)}
        >
          Cancel
        </button>

        <button className="modal-update" onClick={updatePriceSlab}>
          <TickIcon />
          <span>Update Details</span>
        </button>
      </div>

    </div>
  </div>
)}
{showDeletePriceModal && (
  <div className="modal-overlay">
    <div className="delete-price-modal">

      <div className="warning-icon"><WarningIcon /></div>

      <h2>Delete Price Slab?</h2>

      <p>
        Are you sure you want to remove this
        <br />
        price slab?
      </p>

      <div className="delete-slab-name">
        {priceSlabs[deletingPriceIndex]?.slabName || "Unnamed Slab"}
      </div>

      <div className="delete-actions">
        <button
          className="delete-cancel"
          onClick={() => setShowDeletePriceModal(false)}
        >
          Cancel
        </button>

        <button
          className="delete-confirm"
          onClick={confirmDeletePriceSlab}
        >
          Delete
        </button>
      </div>

    </div>
  </div>
)}
      </main>
    </div>
  );
}
  return (
    <div className="settings-page">
      <aside className="sidebar">
  <div
  className={activeMenu === "dashboard" ? "nav-item active" : "nav-item"}
  onClick={() => {
    setActiveMenu("dashboard");
    setPage("dashboard");
  }}
>
  <DashboardIcon />
  <span>Dashboard</span>
</div>

<div
  className={activeMenu === "vehicles" ? "nav-item active" : "nav-item"}
  onClick={() => {
  setActiveMenu("vehicles");
  setPage("vehicle");
}}
>
  <VehicleIcon />
  <span>Vehicles</span>
</div>

<div
  className={activeMenu === "checkin" ? "nav-item active" : "nav-item"}
  onClick={() => {
    setActiveMenu("checkin");
    setPage("checkin");
  }}
>
  <CheckInIcon />
  <span>Check-In</span>
</div>

<div
  className="nav-item"
  onClick={() => {
    setActiveMenu("settings");
  }}
>
  <CheckOutIcon />
  <span>Check-Out</span>
</div>

<div
  className={activeMenu === "analytics" ? "nav-item active" : "nav-item"}
  onClick={() => {
  setActiveMenu("analytics");
  setPage("analytics");
}}
>
  <AnalyticsIcon />
  <span>Analytics</span>
</div>

<div
  className={activeMenu === "settings" ? "nav-item active" : "nav-item"}
  onClick={() => {
    setActiveMenu("settings");
    setPage("settings");
  }}
>
  <SettingsIcon />
  <span>Settings</span>
</div>
</aside>

      <main className="settings-main">
        <h1>Settings</h1>
        <p className="subtitle-setting">ADJUST AND MODIFY THE APPLICATION</p>

        <div className="tabs">
  <button
    className={`tab ${activeTab === "general" ? "active" : ""}`}
    onClick={() => setActiveTab("general")}
  >
    General
  </button>

  <button
    className={`tab ${activeTab === "notifications" ? "active" : ""}`}
    onClick={() => setActiveTab("notifications")}
  >
    Notifications
  </button>

  <button
    className={`tab ${activeTab === "printer" ? "active" : ""}`}
    onClick={() => setActiveTab("printer")}
  >
    Printer
  </button>
</div>

{activeTab !== "general" && (
  <SettingsTabs activeTab={activeTab} />
)}

        {activeTab === "general" && (
<>
        <section className="header-text">
          <h2>General Settings</h2>
          <p>Configure your core parking management parameters and brand identity.</p>
        </section>

        <div className="content-row">
          <div className="left-col">
            <div className="logo-card">
              <h3 className="company-title">
  <CompanyIcon />
  <span className="set-set">Company Identity</span>
</h3>

              <div className="logo-upload">

  {logo ? (
    <img
      src={logo}
      alt="Company Logo"
      className="uploaded-logo"
    />
  ) : (
    <CameraIcon />
  )}

  <input
    type="file"
    id="logoInput"
    accept="image/*"
    onChange={handleLogoUpload}
    hidden
  />

  <button
    className="upload-btn"
    onClick={() =>
      document.getElementById("logoInput").click()
    }
  >
    <UploadIcon />
  </button>

</div>

              <h4>COMPANY LOGO</h4>
              <p>Recommended: 512x512px SVG or PNG</p>
            </div>

            <div className="info-note">
              "These settings are globally applied across all connected parking application interfaces."
            </div>
          </div>

          <div className="form-card">
            <div className="form-grid">
              <div className="field">
                <label>COMPANY NAME</label>
                <div className="input-pill">
  <CompanyNameIcon />
  <input
    type="text"
    placeholder="Enter your company name"
    className="settings-input"
  />
</div>
              </div>

              <div className="field">
                <label>EMAIL ADDRESS</label>
                <div className="input-pill">
  ✉
  <input
    type="email"
    placeholder="Enter your email"
    className="settings-input"
  />
</div>
              </div>

              <div className="field">
                <label>FLOOR CONFIGURATION</label>
                <div className="input-line">
                  <div className="input-pill">
  <FloorIcon />
  <select
  value={selectedFloor}
  onChange={(e) => setSelectedFloor(e.target.value)}
  className="dropdown-select"
>
  <option value="">Select Floor</option>

  {floors.map((floor, index) => (
    <option key={index} value={floor.name}>
      {floor.name}
    </option>
  ))}
</select>
  <span className="dropdown-arrow"><span className="dropdown-icon">
  <DropdownIcon />
</span></span>
</div>
                  <button onClick={() => setShowFloorModal(true)}><PenIcon /></button>
                </div>
              </div>

              <div className="field">
                <label>ACTIVE ZONE</label>
                <div className="input-line">
                  <div className="input-pill"><ZoneIcon />
  <select
  value={selectedZone}
  onChange={(e) => setSelectedZone(e.target.value)}
  className="dropdown-select"
>
  <option value="">Select Zone</option>

  {zones.map((zone, index) => (
    <option key={index} value={zone.name}>
      {zone.name}
    </option>
  ))}
</select>
  <span className="dropdown-arrow"><span className="dropdown-icon">
  <DropdownIcon />
</span></span>
</div>
                  <button onClick={() => setShowZoneModal(true)}><PenIcon /></button>
                </div>
              </div>

              <div className="field">
                <label>BIKE PRICE SLAB</label>
                <div className="input-line">
                  <div className="input-pill">
  <BikeIcon />
  <span>Default</span>
  <span className="dropdown-arrow"><DropdownIcon /></span>
</div>
                  <button onClick={() => setSettingsPage("priceSlab")}><PenIcon /></button>
                </div>
              </div>

              <div className="field">
                <label>CAR PRICE SLAB</label>
                <div className="input-line">
                  <div className="input-pill"><CarIcon />
  <span>Default</span>
  <span className="dropdown-arrow"><DropdownIcon /></span></div>
                  <button onClick={() => setSettingsPage("priceSlab")}><PenIcon /></button>
                </div>
              </div>
            </div>

            <div className="form-actions">
              <button className="cancel-btn-set">Cancel</button>
              <button className="save-btn"><SaveIcon /> Save Changes</button>
            </div>
          </div>
        </div>

        <div className="bottom-cards">
          <div className="mini-card">
            <div className="icon"><CloudIcon /></div>
            <div>
              <h4>Cloud Sync</h4>
              <p>Updates are synchronized to cloud endpoints every 5 minutes.</p>
            </div>
          </div>

          <div className="mini-card">
            <div className="icon"><ShieldIcon /></div>
            <div>
              <h4>Access Log</h4>
              <p>Any changes to these settings are logged for auditing purposes.</p>
            </div>
          </div>
        </div>
        {showZoneModal && (
  <div className="modal-overlay">
    <div className="zone-modal">
      <button className="modal-close" onClick={() => setShowZoneModal(false)}>
        ×
      </button>

      <h2><ZonesprofileIcon />
  <span>Zones Profile</span></h2>
      <p className="modal-subtitle">Customise the Zones of Parking Slot</p>

      <div className="zone-head">
        <span>Zones</span>
        <span>Capacity</span>
      </div>

      {zones.map((item, index) => (
  <div className="zone-row" key={index}>
    <div className="zone-input">
  <input
    className="zone-edit-input"
    placeholder="Enter zone"
    value={item.name}
    onChange={(e) => {
      const updated = [...zones];
      updated[index] = {
        ...updated[index],
        name: e.target.value,
      };
      setZones(updated);
    }}
  />
  

  {item.name.trim() ? (
  <button
    className="delete-btn"
    type="button"
    onClick={() => {
      const updated = zones.filter((_, i) => i !== index);
      setZones(updated);
    }}
  >
    <DeleteprofileIcon />
  </button>
) : (
  <button className="pen-btn" type="button">
    <PenIcon />
  </button>
)}
</div>

    <div className="capacity-input">
      <input
        className="zone-edit-input"
        placeholder="Enter capacity"
        value={item.capacity}
        onChange={(e) => {
  const updated = [...zones];

  updated[index] = {
    ...updated[index],
    capacity: e.target.value,
  };

  setZones(updated);
}}
      />
    </div>
  </div>
))}

<button className="add-zone-btn" onClick={addZoneRow}>
  <PlusIcon />
  Add a New Operating Zone
</button>

      <div className="modal-actions">
        <button className="modal-cancel" onClick={() => setShowZoneModal(false)}>
          Cancel
        </button>
        <button
  className="modal-update"
  onClick={handleZoneSave}
>
  <TickIcon />
  <span>Update Details</span>
</button>
      </div>
    </div>
  </div>
)}
{showFloorModal && (
  <div className="modal-overlay">
    <div className="zone-modal">
      <button className="modal-close" onClick={() => setShowFloorModal(false)}>
        ×
      </button>

      <h2>
        <FloorprofileIcon /> Floor Configuration
      </h2>
      <p className="modal-subtitle">Customise the Configuration of Parking Slot</p>

      <div className="zone-head">
        <span>Floors</span>
        <span>Capacity</span>
      </div>

      {floors.map((item, index) => (
  <div className="zone-row" key={index}>
    <div className="zone-input">
  <input
    className="zone-edit-input"
    placeholder="Enter floor"
    value={item.name}
    onChange={(e) => {
      const updated = [...floors];
      updated[index] = {
        ...updated[index],
        name: e.target.value,
      };
      setFloors(updated);
    }}
  />

  {item.name.trim() ? (
  <button
    className="delete-btn"
    type="button"
    onClick={() => {
      const updated = floors.filter((_, i) => i !== index);
      setFloors(updated);
    }}
  >
    <DeleteprofileIcon />
  </button>
) : (
  <button className="pen-btn" type="button">
    <PenIcon />
  </button>
)}
</div>

    <div className="capacity-input">
      <input
        className="zone-edit-input"
        placeholder="Enter capacity"
        value={item.capacity}
        onChange={(e) => {
          const updated = [...floors];
          updated[index] = {
            ...updated[index],
            capacity: e.target.value,
          };
          setFloors(updated);
        }}
      />
    </div>
  </div>
))}

      <button className="add-zone-btn" onClick={addFloorRow}>
  <PlusIcon />
  Add a New Operating Floor
</button>

      <div className="modal-actions">
        <button className="modal-cancel" onClick={() => setShowFloorModal(false)}>
          Cancel
        </button>
        <button
  className="modal-update"
  onClick={handleFloorSave}
>
  <TickIcon />
  <span>Update Details</span>
</button>
      </div>
    </div>
  </div>
)}

</>
)}

      </main>
    </div>
  );
}
